import { useListAllGitConfigs } from 'Source/graphql/queries/listGitConfigs.generated';
import { useAppConfig } from 'Components/utils/AppBootstrapper/AppConfigContext';

const useIsCreatePROnSaveEnabled = (): { isEnabled: boolean; isLoading: boolean } => {
  const { enablePantherGitConfiguration } = useAppConfig();

  const { data: listGitConfigsData, loading: isLoadingListGitConfigs } = useListAllGitConfigs({
    skip: !enablePantherGitConfiguration,
    variables: {
      input: {
        cursor: null,
        limit: 1,
      },
    },
  });

  const existingGitHubAppConfig =
    listGitConfigsData?.listGitConfigs?.allGitConfigs?.gitHubAppConfigs?.[0];

  return {
    isEnabled: Boolean(enablePantherGitConfiguration && existingGitHubAppConfig),
    isLoading: isLoadingListGitConfigs,
  };
};

export default useIsCreatePROnSaveEnabled;
